import { useAuth as useOidcAuth } from 'react-oidc-context';
import { AuthContextProps } from 'react-oidc-context';

// Extend the AuthContextProps interface to include getAccessToken
interface ExtendedAuthContextProps extends AuthContextProps {
  getAccessToken: () => Promise<string>;
}

// Create a wrapper around the OIDC auth hook that adds getAccessToken
export const useAuth = (): ExtendedAuthContextProps => {
  const auth = useOidcAuth();
  
  const getAccessToken = async () => {
    // Use ID token instead of access token because it contains user attributes
    // (email, website, profile, etc.) needed for organization identification
    if (!auth.user?.id_token) {
      throw new Error('No ID token available');
    }
    return auth.user.id_token;
  };

  return {
    ...auth,
    getAccessToken,
  };
}; 